import Name from '../components/Name'

const Names = () => {
    return(
        <Name/>
        
    )
}

export default Names;